import React from 'react';

const NotFound = () => (
  <div className="not-found">
    <p className="quote">
      Page not found
    </p>
  </div>
);

export default NotFound;
